export const commuteTime = {
  FIFTEEN_MINUTES: 15,
  THIRSTY_MINUTES: 30,
  FORTY_FIVE_MINUTES: 45,
  SIXTE_MINUTES: 60,
  CUSTOM: 'custom',
};
